import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import VueI18n from 'vue-i18n'
import Vuex from 'vuex'


Vue.use(VueRouter);
Vue.use(VueI18n);
Vue.use(Vuex)

Vue.config.productionTip = false;

import messages from './messages.js'
import Store from "./Store.js"
import Locale from './Locale.js'
import { ROUTES, ROUTES_LOCALES } from './routes.js'

var store = new Vuex.Store(Store);

const i18n = new VueI18n({
	locale: 'en-CA',
	fallbackLocale: 'en-CA',
	silentFallbackWarn: true,
	messages: {
		'en-US': Object.assign({}, ROUTES_LOCALES['en-US'], messages['en-US']),
		'en-CA': Object.assign({}, ROUTES_LOCALES['en-CA'], messages['en-CA']),
		'fr-CA': Object.assign({}, ROUTES_LOCALES['fr-CA'], messages['fr-CA'])
	}
});

const router = new VueRouter({
	mode: 'history',
	routes: ROUTES,
	scrollBehavior(to, from, savedPosition) {
		if (to.hash) Vue.nextTick().then(() => document.querySelector(to.hash).scrollIntoView({behavior: 'smooth' }));
		else if (savedPosition) return savedPosition;
		else return { x: 0, y: 0 }
	},
});

router.afterEach((to, from, next) => {
	gtag('config', 'G-WW4GE0F9DV');
});

var changeRoute = (to, next, locale) => {
	i18n.locale = locale.toRFC5646();
	Vue.prototype.$locale = locale;
	localStorage.setItem('locale', locale.toRFC5646());
	document.querySelector('html').setAttribute('lang', locale.language);
	document.querySelector('meta[name=Content-Language]').setAttribute('content', locale.toRFC5646());
	document.querySelector('meta[name=description]').setAttribute('content', i18n.t('general.metaDescription'));
	document.querySelector('title').innerText = i18n.t('general.metaTitle');
	if(to.params.language && to.params.region) return next();
	next(Object.assign({}, locale.toRouteLinkProp(to.name || (to.path === "/" ? 'home' : undefined), undefined, undefined, to.path), { replace: true }));
}

router.beforeEach((to, from, next) => {
	if(to.params.language && to.params.region) changeRoute(to, next, new Locale(to.params.language, to.params.region, i18n));
	else if(localStorage.getItem('locale')) changeRoute(to, next, new Locale(localStorage.getItem('locale').substr(0, 2), localStorage.getItem('locale').substr(3, 2), i18n));
	else {
		Locale.getLocaleFromService(i18n)
		.then(locale => changeRoute(to, next, locale))
		.catch(error => changeRoute(to, next, new Locale("", "", i18n)));
	}
});

new Vue({
	render: h => h(App),
	store,
	router,
	i18n
}).$mount('#app')